<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isRouterAlive: true
    }
  },
  mounted() {

  },
  provide() {
    return {
      reload: this.reload
    }
  },
  methods: {
    reload() {
      console.log('app.vue 执行注入到子组件内的reload方法')
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style>
/*统一的弹窗位置与大小处理*/
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

/*下拉选择和日期选择组合时的样式处理*/
.select-datapicker-select .el-input__inner {
  border-radius: 4px 0 0 4px;
  border-right: 1px solid #eee;
  color: #909399;
}

.select-datapicker-data {
  margin-left: 0 !important;
  border-left: 0;
  border-radius: 0 4px 4px 0;
}

/*下拉选组合input时的样式处理*/
.el-input-group__prepend {
  background-color: #fff;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

</style>
